// strings/brain.ts (M2-T03, rev 5): the WrittenBrain's own phrases, so this task never depends on M2-T02 in the same wave.
import type { StringBank } from '../schema/strings';
export default {
  fallbackLine: '{catchphrase}!',
  gossipFishRare: 'caught {item:a}', gossipFishCaught: 'went fishing and came back with {item:a}', gossipDonation: 'gave the museum {item:a}', gossipHallComplete: 'helped finish a whole museum hall',
  gossipLoanPaidOff: 'paid off their entire house loan', gossipHouseUpgraded: 'got a bigger house', gossipResidentArrived: 'just moved to town',
  gossipMayorChanged: 'became mayor',
} as const satisfies StringBank;
